import * as ko from "knockout";
import { searchCriteria } from "./_searchCriteria";
import { isNullOrUndefinedOrEmpty } from "services";

export class TaskManagementSearchCriteria extends searchCriteria {
  created_dttm_from: KnockoutObservable<Date>;
  created_dttm_to: KnockoutObservable<Date>;
  task_id: KnockoutObservable<string>;
  task_type: KnockoutObservable<string>;
  model_id: KnockoutObservable<string>;
  serial_no: KnockoutObservable<string>;
  recieved_dttm_value: KnockoutObservable<Date>;
  plan_start_dttm_value: KnockoutObservable<Date>;
  plan_end_dttm_value: KnockoutObservable<Date>;
  task_status: KnockoutObservable<string>;
  service_model: KnockoutObservable<string>;
  page_dir: KnockoutObservable<string>;
  task_status_name: KnockoutObservable<string>;
  team_id: KnockoutObservable<string>;
  person_type: KnockoutObservable<"cc_P_NEW_TASK" | "cc_P_OWN_TASK" | "cc_P_OTHER_TASK">;
  planned_start: KnockoutObservable<
    "cc_P_TODAY_TASK" | "cc_P_TOMORROW_TASK" | "cc_P_FUTURE_TASK" | "cc_P_OVERDUE_TASK"
  >;

  constructor(item) {
    super(item);
    this.created_dttm_from = ko.observable(this.formatJSONDate(item.created_dttm_from));
    this.created_dttm_to = ko.observable(this.formatJSONDate(item.created_dttm_to));
    this.task_id = ko.observable(item.task_id);
    this.task_type = ko.observable(item.task_type);
    this.model_id = ko.observable(item.model_id);
    this.serial_no = ko.observable(item.serial_no);
    this.recieved_dttm_value = ko.observable(item.recieved_dttm_value);
    this.plan_start_dttm_value = ko.observable(item.plan_start_dttm_value);
    this.plan_end_dttm_value = ko.observable(item.plan_end_dttm_value);
    this.task_status = ko.observable(item.task_status);
    this.task_status_name = ko.observable(item?.task_status_name);
    this.service_model = ko.observable(item.service_model);
    this.page_dir = ko.observable(item.page_dir);
    this.team_id = ko.observable(item?.team_id);
    this.person_type = ko.observable(item?.person_type);
    this.planned_start = ko.observable(item?.planned_start);

    this.planned_start.subscribe((data) => {
      if (!isNullOrUndefinedOrEmpty(data?.trim())) {
        this.sort_dir("asc");
        this.sort_field("plan_start_dttm");
      }
    });
  }
}
